/* @flow */
import idx from 'idx';
import React from 'react';
import gql from 'graphql-tag';
import once from 'lodash/once';
import Box from 'components/Box.jsx';
import { graphql } from 'react-apollo';
import Button from 'components/Button.jsx';
import BoxBody from 'components/BoxBody.jsx';
import Buttons from 'components/Buttons.jsx';
import BoxHeader from 'components/BoxHeader.jsx';
import { withRouter } from 'app/context/Router.jsx';
import IntegrationSettingsNotFound from './IntegrationSettingsNotFound.jsx';

import './styles/IntegrationSettingsIndex.scss';

type Props = {
  router: *,
  data: ReactApolloData<IntegrationSettingsIndexQuery>,
};

const isAuthorized = (o: any) => o.permissions.canEditDeveloperSettings;

class IntegrationSettingsIndex extends React.Component<Props, {}> {
  props: Props;

  redirectToSettings = once((o: any) => this.props.router.replace(`/integrations/${o.uuid}`));

  renderOrganization = (o: any) => {
    return (
      <Button
        key={o.uuid}
        className="IntegrationSettingsIndex-button"
        onClick={() => this.redirectToSettings(o)}>
        {o.name}
      </Button>
    );
  };

  render() {
    const loading = idx(this.props, _ => _.data.loading);
    const organizations = idx(this.props, _ => _.data.me.organizations) || [];
    const editableOrganizations = organizations.filter(isAuthorized);

    if (loading) {
      return null;
    }

    if (editableOrganizations.length === 0) {
      return <IntegrationSettingsNotFound />;
    }

    if (editableOrganizations.length === 1) {
      this.redirectToSettings(editableOrganizations[0]);
    }

    return (
      <div className="IntegrationSettingsIndex">
        <Box size="medium">
          <BoxHeader title="You have access to multiple organizations settings" />
          <BoxBody>
            <Buttons axis="y">{editableOrganizations.map(this.renderOrganization)}</Buttons>
          </BoxBody>
        </Box>
      </div>
    );
  }
}

const withOrganizations = graphql(gql`
  query IntegrationSettingsIndex {
    me {
      uuid
      organizations {
        uuid
        name
        permissions {
          canEditDeveloperSettings
        }
      }
    }
  }
`);

export { IntegrationSettingsIndex };
export default withRouter(withOrganizations(IntegrationSettingsIndex));
